"use strict";

exports.__esModule = true;
exports.AggregateMetricChartFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _Core = require("../../Core");
var _fetchSection = require("../../VIMANAMetrics/Sections/fetchSection");
var _aggregates = require("../../VIMANAMetrics/Sections/aggregates");
var _MetricsFilters = require("../common/MetricsFilters");
var _Metrics = require("../../Metrics");
var _MultiAggregateSelector = require("../common/MultiAggregateSelector");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AggregateMetricChartFields = exports.AggregateMetricChartFields = function AggregateMetricChartFields(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  var _element$props = element.props,
    hideXAxis = _element$props.hideXAxis,
    hideXUnits = _element$props.hideXUnits,
    hideYAxis = _element$props.hideYAxis,
    showLegends = _element$props.showLegends,
    showChartTooltip = _element$props.showChartTooltip;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var aggregates = (0, _fetchSection.fetchSection)("aggregates");
  var selectedAggregates = element.props.aggregations.filter(function (child) {
    return child.section === "aggregates";
  });
  var aggregationItems = (0, _MetricsFilters.flattenAggregates)([_aggregates.byTime, _aggregates.byDevice, _aggregates.byShift]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.Well, null, /*#__PURE__*/_react["default"].createElement(_styles.WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "X Axis")), /*#__PURE__*/_react["default"].createElement(_MultiAggregateSelector.MultiAggregateSelector, {
    items: aggregationItems,
    tags: aggregates.map(function (_ref) {
      var name = _ref.name;
      return name;
    }),
    selected: selectedAggregates,
    onSelect: function onSelect(selected) {
      if (!(0, _reactFastCompare["default"])(selectedAggregates, selected)) {
        var groups = selected.reduce(function (acc, item) {
          acc[item.groupId] = item;
          return acc;
        }, {});
        var values = Object.values(groups);
        elementEditor.setProps(path, {
          aggregations: values
        });
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_styles.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("Chart.hideXAxis", "Hide Axis"),
    checked: hideXAxis,
    onChange: function onChange() {
      elementEditor.setProp(path, "hideXAxis", !hideXAxis);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("Chart.hideXLabel", "Hide Label"),
    checked: hideXUnits,
    onChange: function onChange() {
      elementEditor.setProp(path, "hideXUnits", !hideXUnits);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_styles.Well, null, /*#__PURE__*/_react["default"].createElement(_styles.WellTitle, null, translate("MetricChartFields.axes.yaxis.label", "Y Axis")), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("MetricSelector.placeholder.single", "Select Metric")
  }, /*#__PURE__*/_react["default"].createElement(_Metrics.MetricChartSeriesControls, {
    availableSeriesType: ["bar"],
    metricSelectorWidth: 140,
    value: element.props.metricChartSeries,
    onChange: function onChange(selectedMetricsMetaData) {
      elementEditor.setProp(path, "metricChartSeries", selectedMetricsMetaData);
    }
  })), /*#__PURE__*/_react["default"].createElement(_styles.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("Chart.hideYAxis", "Hide Axis"),
    checked: hideYAxis,
    onChange: function onChange() {
      elementEditor.setProp(path, "hideYAxis", !hideYAxis);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_styles.LegendsWell, null, /*#__PURE__*/_react["default"].createElement(_styles.WellTitle, null, translate("MetricChartFields.showLegends", "Legend")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("Chart.showLegends", "Show Legend"),
    checked: showLegends,
    onChange: function onChange() {
      elementEditor.setProp(path, "showLegends", !showLegends);
    }
  })), /*#__PURE__*/_react["default"].createElement(_styles.TooltipWell, null, /*#__PURE__*/_react["default"].createElement(_styles.WellTitle, null, translate("DataItem.Tooltip.label", "Tooltip")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("DaaItem.showChartTooltip.label", "Show Chart Tooltip"),
    checked: showChartTooltip,
    onChange: function onChange() {
      elementEditor.setProp(path, "showChartTooltip", !showChartTooltip);
    }
  })));
};